// CallContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the shape of the context value
interface CallContextType {
  isCalling: boolean;
  setIsCalling: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create the context with a default value
const CallContext = createContext<CallContextType | undefined>(undefined);

interface CallProviderProps {
  children: ReactNode; // Define the type for children
}

export const CallProvider: React.FC<CallProviderProps> = ({ children }) => {
  const [isCalling, setIsCalling] = useState(false);

  return (
    <CallContext.Provider value={{ isCalling, setIsCalling }}>
      {children}
    </CallContext.Provider>
  );
};

// Custom hook to use the CallContext
export const useCallContext = () => {
  const context = useContext(CallContext);
  if (context === undefined) {
    throw new Error('useCallContext must be used within a CallProvider');
  }
  return context;
};